import axios from 'axios'

window.axios = axios;

const ApiDevUrl = 'https://sup.server2.voatt.cz/registration-app';
const ApiProdUrl = '//rezervace.sup-pardubice.cz/prihlaseni/registration-app';

const host = window.location.host;

const baseUrl = host === "rezervace.sup-pardubice.cz" || host === "rezervace.sup-hradec.cz" ? ApiProdUrl : ApiDevUrl;

const STORE_COOKIE = 'STORE_COOKIE';

const STORE_HK = 24;
const STORE_PCE = 23;

function getStore() {

  if(window.location.hostname === 'rezervace.sup-pardubice.cz') {
    return STORE_PCE;
  } else if (window.location.hostname === 'rezervace.sup-hradec.cz') {
    return STORE_HK;
  } else {
    return $cookies.isKey(STORE_COOKIE) && $cookies.get(STORE_COOKIE) === 'hk' ? STORE_HK : STORE_PCE;
  }
}

let instance = axios.create({
    baseURL: baseUrl,
    timeout: 30000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/plain',
        // 'Authorization': 'Basic c3VwOnN1cA==',
    },
    auth: {
        username: 'sup',
        password: 'sup',
    },
});

export const init = function (page) {
    return instance.get('/init', {
      params: {
        page: page,
        store: getStore(),
      }
    });
}

export const getVolnaMistaAkce = function (id) {
    return instance.get('/akce-kapacita', {
        params: {
            id: id,
        }
    });
}

export const getVolnaMistaHlavniSluzba = function (params) {
  params.store = getStore();

  return instance.get('/hlavni-sluzba-kapacita', {
    params: params
  });
}

export const getAkceKolobezkyKapacita = function (params) {
  params.store = getStore();

  return instance.get('/akce-kolobezky-kapacita', {
    params: params
  });
}

export const getCenyHlavniSluzba = function () {
  return instance.get('/pujcovna-slevy', {
    params: { store: getStore() }
  });
}

export const sendOrder = function (store) {
    store.store = getStore();

    return instance.post('/order/create', store);
}

export const getPujcovnaEvents = function (from, to) {
    return instance.get('/get-pujcovna-events', {
      params: {
        from: from,
        to: to,
        store: getStore(),
      }
    });
}



// WEBPACK FOOTER //
// ./src/api/api.js